import { type BaseTemplateProps } from '../NotificationTemplate'
import { type TemplateDefinition } from '../TemplateRegistry'

interface ArYodaRulesCreatedNotifyAuthorProps extends BaseTemplateProps {
  request: {
    id: string
    name: string
  }
}

export const ArYodaRulesCreatedNotifyAuthor: TemplateDefinition<ArYodaRulesCreatedNotifyAuthorProps> =
  {
    renderParams: (props: ArYodaRulesCreatedNotifyAuthorProps) => ({
      messageKey: 'notificationsDomain.templates.arYodaRulesCreatedNotifyAuthor',
      values: {
        requestId: props?.request?.id,
        ruleName: props?.request?.name,
      },
    }),
  }
